<div class="bag-selector">
  <lh-shared-ui-numeric-up-down
    [value]="numberOfBags$ | async"
    (valueChange)="onNumberOfBagsChange($event)"
    [min]="minNumberOfBags"
    [max]="maxNumberOfBags"
  ></lh-shared-ui-numeric-up-down>
</div>
